<div class="contact-container">
  <h1 class="contact-title">Contacto</h1>

  <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
    <div class="form-group">
      <label for="email" class="form-label">Correo electrónico</label>
      <input
        type="email"
        id="email"
        formControlName="email"
        class="form-input"
      />
      <div
        *ngIf="
          contactForm.get('email')?.invalid && contactForm.get('email')?.touched
        "
        class="form-error"
      >
        Correo electrónico inválido
      </div>
    </div>
    <div class="form-group">
      <label for="message" class="form-label">Mensaje</label>
      <textarea
        id="message"
        formControlName="message"
        class="form-input"
      ></textarea>
      <div
        *ngIf="
          contactForm.get('message')?.invalid &&
          contactForm.get('message')?.touched
        "
        class="form-error"
      >
        El mensaje es obligatorio
      </div>
    </div>
    <button type="submit" class="submit-btn" [disabled]="contactForm.invalid">
      Enviar
    </button>
  </form>

  <h2 class="section-title">Números de contacto</h2>
  <div class="phone-list-wrapper">+54 2235803716</div>

  <h2 class="section-title">Email de contacto</h2>
  <div class="phone-list-wrapper">contactfitfactory.com</div>
  o
  <h2 class="section-title">Preguntas frecuentes</h2>
  <div *ngFor="let faq of faqs; let i = index" class="faq-item">
    <button (click)="toggleFaq(i)" class="faq-question-btn">
      <h3 class="faq-question">{{ faq.question }}</h3>
    </button>
    <div *ngIf="faq.open" class="faq-answer">
      <p>{{ faq.answer }}</p>
    </div>
  </div>
</div>
